import { getCurrentInstance, onBeforeUnmount, readonly, ref, unref, watchEffect } from 'vue';

const breadcrumbTitle = ref(null);
let currentOwner = null;

/**
 * Label of the last breadcrumb for a page that is not a nav item itself
 * (e.g. a connections channel). Read by `UiBreadcrumbs`.
 */
export const breadcrumbTitleOverride = readonly(breadcrumbTitle);

/**
 * Sets the last breadcrumb's label for as long as the calling page is mounted.
 * @param {import('vue').MaybeRef<string|null|undefined>} title
 */
export function useBreadcrumbTitle(title) {
  const owner = Symbol('breadcrumb-title');

  const stop = watchEffect(() => {
    currentOwner = owner;
    breadcrumbTitle.value = unref(title) || null;
  });

  if (getCurrentInstance()) {
    onBeforeUnmount(() => {
      stop();
      // The next page may already have set its own title.
      if (currentOwner === owner) {
        currentOwner = null;
        breadcrumbTitle.value = null;
      }
    });
  }
}
